// Mega Menu Hover Handler - Show/Hide Pre-rendered Menus
document.addEventListener('DOMContentLoaded', function() {
  const menuTriggers = document.querySelectorAll('.has-mega-menu');
  const megaMenuContainer = document.getElementById('mega-menu-container');
  const megaMenuContent = megaMenuContainer ? megaMenuContainer.querySelector('.mega-menu__content') : null;
  const nav = document.getElementById('main-header-nav');
  
  let closeTimeout = null;
  let currentTrigger = null;
  let currentMegaMenu = null;
  
  if (!megaMenuContainer || !megaMenuContent) {
    console.warn('Mega menu container or content not found');
    return;
  }
  
  if (menuTriggers.length === 0) {
    console.warn('No menu triggers found');
    return;
  }
  
  console.log('Mega menu initialized with', menuTriggers.length, 'triggers');
  
  // Function to position mega menu below header
  function positionMegaMenu() {
    if (nav) {
      const navRect = nav.getBoundingClientRect();
      // megaMenuContainer.style.top = (navRect.bottom + window.scrollY) + 'px';
    }
  }
  
  // Function to update mega menu content height
  function updateMegaMenuHeight(megaMenu) {
    // Get current height
    const currentHeight = megaMenuContent.offsetHeight;
    
    // Temporarily disable transition and set to auto to measure natural height
    megaMenuContent.style.transition = 'none';
    megaMenuContent.style.height = 'auto';
    
    // Get the natural height including padding
    const newHeight = megaMenuContent.offsetHeight;
    
    // Set back to current height (without transition)
    megaMenuContent.style.height = currentHeight + 'px';
    
    // Force a reflow
    megaMenuContent.offsetHeight;
    
    // Re-enable transition
    megaMenuContent.style.transition = '';
    
    // Now set to new height (with transition)
    megaMenuContent.style.height = newHeight + 'px';
  }
  
  // Function to show mega menu with specific content
  function showMegaMenu(trigger, menuId) {
    console.log('Showing mega menu:', menuId);
    
    // Clear any pending close
    if (closeTimeout) {
      clearTimeout(closeTimeout);
      closeTimeout = null;
    }
    
    // Find the mega menu element
    const megaMenu = document.getElementById(menuId);
    if (!megaMenu) {
      console.error('Mega menu not found:', menuId);
      return;
    }
    
    // Check if this is the first time opening or switching menus
    const isFirstOpen = !megaMenuContainer.classList.contains('is-active');
    
    // Hide all mega menus
    const allMegaMenus = megaMenuContainer.querySelectorAll('[data-mega-menu]');
    allMegaMenus.forEach(menu => {
      menu.classList.remove('is-active');
    });
    
    // Show the selected mega menu
    megaMenu.classList.add('is-active');
    currentMegaMenu = megaMenu;
    
    // Position mega menu
    positionMegaMenu();
    
    // Remove active class from all triggers
    menuTriggers.forEach(t => t.classList.remove('is-active'));
    
    // Show mega menu container and activate trigger
    megaMenuContainer.classList.add('is-active');
    trigger.classList.add('is-active');
    currentTrigger = trigger;
    
    // Calculate and set height after menu is displayed
    // Use requestAnimationFrame to ensure the display:block has been applied
    requestAnimationFrame(() => {
      updateMegaMenuHeight(megaMenu);
    });
    
    console.log('Mega menu shown');
  }
  
  // Function to hide mega menu
  function hideMegaMenu() {
    closeTimeout = setTimeout(() => {
      console.log('Hiding mega menu');
      megaMenuContainer.classList.remove('is-active');
      
      // Hide current mega menu
      if (currentMegaMenu) {
        currentMegaMenu.classList.remove('is-active');
        currentMegaMenu = null;
      }
      
      // Reset height after transition
      setTimeout(() => {
        if (!megaMenuContainer.classList.contains('is-active')) {
          megaMenuContent.style.height = '';
        }
      }, 300); // Match CSS transition duration
      
      // Deactivate trigger
      if (currentTrigger) {
        currentTrigger.classList.remove('is-active');
        currentTrigger = null;
      }
    }, 150); // Small delay to allow moving to mega menu
  }
  
  // Add hover listeners to menu items
  menuTriggers.forEach(trigger => {
    const menuId = trigger.getAttribute('data-menu-id');
    if (!menuId) {
      console.warn('Menu trigger missing data-menu-id', trigger);
      return;
    }
    
    console.log('Setting up trigger for:', menuId);
    
    // Mouse enter trigger
    trigger.addEventListener('mouseenter', function() {
      console.log('Mouse enter:', menuId);
      showMegaMenu(trigger, menuId);
    });
    
    // Mouse leave trigger
    trigger.addEventListener('mouseleave', function() {
      console.log('Mouse leave:', menuId);
      hideMegaMenu();
    });
    
    // Click prevention on desktop (optional - remove if you want links to work)
    trigger.addEventListener('click', function(e) {
      if (window.innerWidth >= 990) {
        e.preventDefault();
      }
    });
  });
  
  // Keep mega menu open when hovering over it
  megaMenuContainer.addEventListener('mouseenter', function() {
    console.log('Mouse enter mega menu container');
    if (closeTimeout) {
      clearTimeout(closeTimeout);
      closeTimeout = null;
    }
  });
  
  // Close mega menu when leaving it
  megaMenuContainer.addEventListener('mouseleave', function() {
    console.log('Mouse leave mega menu container');
    hideMegaMenu();
  });
  
  // Reposition on scroll and resize
  window.addEventListener('scroll', positionMegaMenu);
  window.addEventListener('resize', function() {
    positionMegaMenu();
    // Recalculate height if a menu is active
    if (currentMegaMenu) {
      updateMegaMenuHeight(currentMegaMenu);
    }
  });
  
  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
      }
      megaMenuContainer.classList.remove('is-active');
      
      if (currentMegaMenu) {
        currentMegaMenu.classList.remove('is-active');
        currentMegaMenu = null;
      }
      
      // Reset height
      setTimeout(() => {
        megaMenuContent.style.height = '';
      }, 300);
      
      if (currentTrigger) {
        currentTrigger.classList.remove('is-active');
        currentTrigger = null;
      }
    }
  });
  
  // Close when clicking outside
  document.addEventListener('click', function(e) {
    if (!megaMenuContainer.contains(e.target) && 
        !e.target.closest('.has-mega-menu')) {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
      }
      megaMenuContainer.classList.remove('is-active');
      
      if (currentMegaMenu) {
        currentMegaMenu.classList.remove('is-active');
        currentMegaMenu = null;
      }
      
      // Reset height
      setTimeout(() => {
        megaMenuContent.style.height = '';
      }, 300);
      
      if (currentTrigger) {
        currentTrigger.classList.remove('is-active');
        currentTrigger = null;
      }
    }
  });
  
  // Initial positioning
  positionMegaMenu();
});

